import 'tinymce/tinymce';
// Toolbar icons
import 'tinymce/icons/default';
// DOM model
import 'tinymce/models/dom/model';
// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/emoticons';
// importing plugin resources
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/image';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/quickbars';
import 'tinymce/plugins/save';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/help/js/i18n/keynav/en.js';
import 'tinymce/plugins/help/js/i18n/keynav/ar.js';
import 'tinymce/plugins/help/js/i18n/keynav/tr.js';

// Theme
import 'tinymce/themes/silver';

// Content styles, including inline UI like fake cursors
import darkContentCss from 'tinymce/skins/content/dark/content.min.css?inline';
import contentCss from 'tinymce/skins/content/default/content.min.css?inline';
import darkContentUiCss from 'tinymce/skins/ui/oxide-dark/content.min.css?inline';
import contentUiCss from 'tinymce/skins/ui/oxide/content.min.css?inline';

import { Editor } from '@tinymce/tinymce-react';
import { useSelector } from 'react-redux';

const BundledTextEditor = (props) => {
	const { init, ...rest } = props;
	const darkMode = useSelector((state) => state.layout.darkMode);
	const localization = useSelector((state) => state.layout.localization);

	// note that skin and content_css is disabled to avoid the normal
	// loading process and is instead loaded as a string via content_style
	return (
		<Editor
			init={{
				...init,
				license_key: 'gpl',
				skin: false,
				/* eslint-disable camelcase */
				content_css: false,
				content_style: [
					darkMode ? darkContentCss : contentCss,
					darkMode ? darkContentUiCss : contentUiCss,
					init?.content_style || ''
				].join('\n'),
				promotion: false,
				plugins:
					'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
				menubar: 'file edit view insert format tools table help',
				toolbar:
					'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample | ltr rtl',
				contextmenu: 'link image table',
				language: localization.tinyMCELanguage,
				language_url: localization.tinyMCELanguageUrl,
				entity_encoding: 'raw' // this is important to avoid html encoding issues
				/* eslint-enable camelcase */
			}}
			{...rest}
		/>
	);
};

export default BundledTextEditor;